var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDialogClose = function SvgDialogClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.548 0 9 7.452 16.452 0 18 1.548 10.548 9 18 16.452 16.452 18 9 10.548 1.548 18 0 16.452 7.452 9 0 1.548 1.548 0Z",
    fill: "#333"
  })));
};
export { SvgDialogClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNTQ4MzkgMEw5IDcuNDUxNjFMMTYuNDUxNiA2LjM5NTc3ZS0wN0wxOCAxLjU0ODM5TDEwLjU0ODQgOUwxOCAxNi40NTE2TDE2LjQ1MTYgMThMOSAxMC41NDg0TDEuNTQ4MzkgMThMMCAxNi40NTE2TDcuNDUxNjEgOUwxLjMzNDM1ZS0wOSAxLjU0ODM5TDEuNTQ4MzkgMFoiIGZpbGw9IiMzMzMzMzMiLz4KPC9zdmc+Cg==";